import { render } from "./LabelInfo.vue?vue&type=template&id=501f5e24&scoped=true"
import script from "./LabelInfo.vue?vue&type=script&lang=js"
export * from "./LabelInfo.vue?vue&type=script&lang=js"

import "./LabelInfo.vue?vue&type=style&index=0&id=501f5e24&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501f5e24"]])

export default __exports__